


export class AppAvailabilityDto
{
    public catalog: boolean;
    public library: boolean;
    public servicesMatrix: boolean;
    public spaceBot: boolean;
    public management: boolean;
    public tracker: boolean;
    public marketplace: boolean;
    public monitoring: boolean;
    public vendor: boolean;
}